import React from "react";
import HeroSection from "../../../Components/Common/HeroSection";
import { useLocation } from "react-router-dom";
import { StaticPageApiUrls } from "../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import Button from "../../../Components/Common/Button";
import { customFetcher } from "../../../Api/swrConfig";
import { useAuth } from "../../../Context/AuthContext";
import { Loader } from "../../../Components/Common/Loader";
import { motion } from "framer-motion";

const FreeFeTestCivil = () => {
  const location = useLocation();
  const { token } = useAuth();

  const slug = location.pathname.replace("/civil/", "");
  const { data, isLoading } = useSWR(
    slug ? StaticPageApiUrls.info(slug) : null,
    (url) => customFetcher(url, token)
  );

  const handleDownload = (url, title) => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank"; // Opens in a new tab
    anchor.rel = "noopener noreferrer";
    anchor.download = url.split("/").pop() || "download"; // Extract filename
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 1, y: -40 }} // Start above the view
      whileInView={{ opacity: 1, y: 0 }} // End at normal position
      transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
    >
      <HeroSection
        title={
          isLoading
            ? ""
            : data?.data?.displayTitle ||
              data?.data?.title ||
              "Our FE Civil Model Tests"
        }
        backgroundImage={
          "https://storage.googleapis.com/road-to-fe/uploads/1741417535659-07d447cd-82a2-4b1b-8c08-9fffeaaefa18-colleagues-doing-team-work-project_23-2149361607.avif"
        }
        subtitle={
          isLoading
            ? ""
            : data?.data?.headerDescription || "One Platform Many Options To Explore"
        }
      />
      <div className="gap-3 container mx-auto sm:mt-12 mt-4 flex justify-center md:justify-between items-start flex-wrap md:flex-nowrap px-2">
        {/* Left Content */}
        <div
          className="max-w-5xl w-full"
          dangerouslySetInnerHTML={{ __html: data?.data?.bodyDescription }}
        />

        {/* Right Image */}
        <div className="">
          <img
            src={data?.data?.image}
            alt="Course"
            className="w-full h-72 object-cover rounded-md"
          />
        </div>
      </div>

      <h2 className="text-3xl font-semibold text-primary text-center mt-4">
        {`Try our ${
          data?.data?.displayTitle || data?.data?.title || "Free Model Tests"
        }!`}
      </h2>
      <div className="flex justify-center items-center">
        {/* {userData ? ( */}
        <div className="container mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 p-6">
          {data?.data?.tests?.length
            ? data.data.tests.map((item) => (
                <div
                  key={item._id}
                  className="bg-white shadow-md hover:shadow-xl rounded-lg p-4 transition-all duration-300"
                >
                  {/* Image with download */}
                  <button
                    onClick={() => handleDownload(item.link, item.title)}
                    className="block w-full flex justify-center"
                  >
                    {item?.link?.endsWith(".pdf") ? (
                      <img
                        src={
                          "https://storage.googleapis.com/road-to-fe/uploads/1741110111744-5fb0db0b-ee21-4a9e-82f4-f09d87b3bbc6-pdfIcon.png"
                        }
                        alt={item.title}
                        className="w-36 h-36 object-cover transform group-hover:scale-110 transition-transform duration-300"
                      />
                    ) : (
                      <img
                        src={item.link}
                        alt={item.title}
                        className="w-full h-28 object-cover rounded-md"
                      />
                    )}
                  </button>

                  <div className="flex flex-col items-center mt-3 gap-1">
                    {/* Title */}
                    <h2 className="text-sm font-semibold">{item.title}</h2>

                    {/* Price */}
                    {/* <p className="text-xs text-gray-500">
                      {item.free ? "Free" : `$${item.price}`}
                    </p> */}

                    {/* Download Button */}
                    <Button
                      onClick={() => handleDownload(item.link, item.title)}
                    >
                      {item.actionButton}
                    </Button>
                  </div>
                </div>
              ))
            : null}
        </div>
        {/* ) : (
          <Link to="/login" className="mt-6">
            <Button type="primary" className="w-full">
              Login
            </Button>
          </Link>
        )} */}
      </div>
    </motion.div>
  );
};

export default FreeFeTestCivil;
